<template>
  <div>
    <div class="md-layout md-alignment-center-left">
      <div v-if="appLatest">
        当前最新发布的版本：{{ appLatest.version_name }}<a v-bind:href="appLatest.url">下载</a>
      </div>
      <div v-else>
        当前没有已发布的新版本
      </div>
    </div>

    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item md-size-40">
        <md-field>
          <label>输入默认应用市场地址</label>
          <md-input v-model="apkData.apk_url"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40">
        <md-field>
          <label>输入小米应用市场地址</label>
          <md-input v-model="apkData.mi_url"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40">
        <md-field>
          <label>输华为应用市场地址</label>
          <md-input v-model="apkData.huawei_url"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40">
        <md-field>
          <label>输OPPO应用市场地址</label>
          <md-input v-model="apkData.oppo_url"></md-input>
        </md-field>
      </div>
      <div class="md-layout-item md-size-40">
        <md-field>
          <label>输VIVO应用市场地址</label>
          <md-input v-model="apkData.vivo_url"></md-input>
        </md-field>
      </div>
    </div>

    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item md-size-10" id="url_modify">
        <md-button class="md-raised md-primary" @click="setAppStoreUrl()">
          设置地址
        </md-button>
      </div>
    </div>
    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item md-size-10">
        <div>
          APP功能
        </div>
      </div>
      <div class="md-layout-item md-size-10">
        <md-checkbox v-model="appFunctionArray" value="1">音乐</md-checkbox>
        <md-checkbox v-model="appFunctionArray" value="2">电话</md-checkbox>
        <md-checkbox v-model="appFunctionArray" value="4">导航</md-checkbox>
        <md-checkbox v-model="appFunctionArray" value="8">电台</md-checkbox>
      </div>
      <div class="md-layout-item md-size-10">
        <md-button class="md-raised md-accent" @click="saveAppFunction()">
          保存APP功能
        </md-button>
      </div>
    </div>
    <div class="md-layout md-alignment-center-left">
      <div class="md-layout-item md-size-10">
        <div>
          APP实名
        </div>
      </div>
      <div class="md-layout-item md-size-10">
        <md-checkbox v-model="appRealName">启用实名</md-checkbox>
      </div>
      <div class="md-layout-item md-size-10">
        <md-button class="md-raised md-accent" @click="saveRealName()">
          保存APP实名
        </md-button>
      </div>
    </div>
    <div class="md-layout md-alignment-center-right">
      <div class="md-layout-item md-size-10">
        <md-button class="md-raised md-primary" @click="showUploadDialog">上传APK</md-button>
      </div>
    </div>
    <md-table>
      <md-table-row>
        <md-table-head class="table_head">APP名称</md-table-head>
        <md-table-head class="table_head">平台</md-table-head>
        <md-table-head class="table_head">状态</md-table-head>
        <md-table-head class="table_head">更新内容</md-table-head>
        <md-table-head class="table_head">版本</md-table-head>
        <md-table-head class="table_head">是否强制更新</md-table-head>
        <md-table-head class="table_head">上传时间</md-table-head>
      </md-table-row>

      <md-table-row
          v-for="(item) in appList"
          v-bind:key="item.id">
        <md-table-cell>{{ item.name }}</md-table-cell>
        <md-table-cell>{{ item.platform }}</md-table-cell>
        <md-table-cell>{{ item.status }}</md-table-cell>
        <md-table-cell><span v-html="item.desc"></span></md-table-cell>
        <md-table-cell>{{ item.version_name }}</md-table-cell>
        <md-table-cell>{{ item.force_update }}</md-table-cell>
        <md-table-cell>{{ new Date(item.upload_time).toLocaleString() }}</md-table-cell>
        <md-table-cell><a v-bind:href="item.url">下载</a></md-table-cell>
        <md-table-cell>
          <md-button class="md-accent" @click="publish(item)">
            {{ item.status === 'publish' ? '撤销' : '发布' }}
          </md-button>
        </md-table-cell>
      </md-table-row>

    </md-table>

    <md-dialog :md-active.sync="showPublishDialog">
      <md-dialog-title>发布APK</md-dialog-title>
      <div id="publish_content">
        <md-field md-inline>
          <label>更新提示</label>
          <md-textarea v-model="descPublish" md-autogrow></md-textarea>
        </md-field>
        <md-checkbox v-model="publishForceUpdate">强制更新</md-checkbox>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showPublishDialog = false">取消</md-button>
        <md-button class="md-primary" @click="publishApk">发布</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="apkUploadDialog">
      <md-dialog-title>APK上传</md-dialog-title>
      <div class="md-layout">
        <md-field>
          <label>请选择APK文件</label>
          <md-file accept="application/vnd.android.package-archive" name="apk" @change="inputFileChange"/>
        </md-field>
      </div>
      <md-dialog-actions>
        <md-button class="md-primary" @click="apkUploadDialog = false">取消</md-button>
        <md-button class="md-primary" @click="uploadApk">上传</md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="loading" :md-close-on-esc=false :md-click-outside-to-close=false>
      <div class="md-layout md-alignment-center-center" id="loading_content">
        <md-progress-spinner md-mode="indeterminate"></md-progress-spinner>
      </div>
    </md-dialog>

    <md-snackbar :md-active.sync="toast">{{ toastMsg }}</md-snackbar>
  </div>
</template>

<script>
export default {
  name: "VersionManager",
  data: () => (
      {
        appLatest: null,
        apkData: {
          apk_url: null,
          mi_url: null,
          huawei_url: null,
          oppo_url: null,
          vivo_url: null,
        },
        appList: null,
        appFunctionArray: [],
        appRealName: false,
        showPublishDialog: false,
        apkToPublish: null,
        descPublish: '',
        publishForceUpdate: false,
        apkUploadDialog: false,
        apkImportFile: null,
        toast: false,
        toastMsg: "",
        loading: false,
      }
  ),
  mounted() {
    this.loadLatestVersion();
    this.loadAppList();
    this.loadAppFunction();
  },
  methods: {
    loadLatestVersion: function () {
      this.$http.post('/api/version/upgrade/', {
        application_id: 'cn.szyundong.carassist',
        platform: 'android',
        channel: 'official',
        identification_code: 'web',
      }).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.appLatest = data.data;
                if (this.appLatest.apk_data) {
                  this.apkData = this.appLatest.apk_data;
                }
              } else {
                switch (data.code) {
                  case 10100:
                    this.appLatest = null;
                    this.showErrorTips('当前没有已发布的新版本');
                    break
                  default:
                    this.showErrorTips('获取最新版本失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    loadAppList: function () {
      this.$http.get('/api/version/list/')
          .then(
              response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.appList = data.data.apps;
                  } else {
                    switch (data.code) {
                      default:
                        this.showErrorTips('获取版本列表失败，服务器返回错误码' + data.code);
                        break
                    }
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            if (error.response.status === 403) {
              localStorage.clear();
              this.$router.replace('/login')
            } else {
              this.showErrorTips('未知错误' + error);
            }
          })
    },
    loadAppFunction: function () {
      this.$http.get('/api/app/globalSettings')
          .then(
              response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.appRealName = data.data.settings.forceRealName
                    let appFunction = data.data.settings.app_function.appFunction
                    if ((appFunction & 1) === 1) {
                      this.appFunctionArray.push("1")
                    }
                    if ((appFunction & 2) === 2) {
                      this.appFunctionArray.push("2")
                    }
                    if ((appFunction & 4) === 4) {
                      this.appFunctionArray.push("4")
                    }
                    if ((appFunction & 8) === 8) {
                      this.appFunctionArray.push("8")
                    }
                    console.log(appFunction)
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            this.showErrorTips('未知错误' + error);
          })
    },
    saveAppFunction: function () {
      let app = 0;
      this.appFunctionArray.forEach(item => {
        app = app | parseInt(item)
      });
      this.$http.put('/api/app/function/' + app + '/')
          .then(
              response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.showTips('保存成功');
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            this.showErrorTips('未知错误' + error);
          })
    },
    saveRealName: function () {
      this.$http.post('/api/app/real/' + this.appRealName + '/')
          .then(
              response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.showTips('保存成功');
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            this.showErrorTips('未知错误' + error);
          })
    },
    showUploadDialog: function () {
      this.apkUploadDialog = true;
    },
    uploadApk: function () {
      this.apkUploadDialog = false;
      this.loading = true;
      let postData = new FormData();
      postData.append('app_install_file', this.apkImportFile);
      this.$http.post('/api/version/upload/', postData)
          .then(response => {
            this.loading = false;
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips('上传成功');
                this.loadAppList();
              } else {
                switch (data.code) {
                  default:
                    this.showErrorTips('上传失败，服务器返回错误码' + data.code);
                    break
                }
              }
            }
          })
          .catch(error => {
            this.loading = false;
            this.showErrorTips('未知错误' + error);
          });

    },
    inputFileChange(e) {
      this.apkImportFile = e.target.files[0]
    },
    publish: function (item) {
      if (item.status === 'publish') {
        this.$http.post('/api/version/revert/' + item.id + '/')
            .then(
                response => {
                  if (response.status === 200) {
                    let data = response.data;
                    if (data.code === 0) {
                      this.loadLatestVersion();
                      this.loadAppList();
                    } else {
                      switch (data.code) {
                        default:
                          this.showErrorTips('发布失败，服务器返回错误码' + data.code);
                          break
                      }
                    }
                  } else {
                    this.showErrorTips('请求失败，HTTP错误码' + response.status);
                  }
                }
            )
            .catch(error => {
              if (error.response.status === 403) {
                localStorage.clear();
                this.$router.replace('/login')
              } else {
                this.showErrorTips('未知错误' + error);
              }
            })
      } else {
        this.apkToPublish = item;
        this.descPublish = item.desc;
        this.publishForceUpdate = item.force_update;
        this.showPublishDialog = true;
      }
    },
    publishApk: function () {
      this.showPublishDialog = false
      this.$http.post('/api/version/publish/' + this.apkToPublish.id + '/', {
        desc: this.descPublish,
        gray: 1,
        force_update: this.publishForceUpdate
      })
          .then(response => {
                if (response.status === 200) {
                  let data = response.data;
                  if (data.code === 0) {
                    this.loadLatestVersion();
                    this.loadAppList();
                  } else {
                    switch (data.code) {
                      default:
                        this.showErrorTips('发布失败，服务器返回错误码' + data.code);
                        break
                    }
                  }
                } else {
                  this.showErrorTips('请求失败，HTTP错误码' + response.status);
                }
              }
          )
          .catch(error => {
            if (error.response.status === 403) {
              localStorage.clear();
              this.$router.replace('/login')
            } else {
              this.showErrorTips('未知错误' + error);
            }
          })
    },
    setAppStoreUrl: function () {
      this.$http.post('/api/app/apk/url/', {
        apk_url: this.apkData.apk_url,
        mi_url: this.apkData.mi_url,
        huawei_url: this.apkData.huawei_url,
        oppo_url: this.apkData.oppo_url,
        vivo_url: this.apkData.vivo_url,
      }).then(
          response => {
            if (response.status === 200) {
              let data = response.data;
              if (data.code === 0) {
                this.showTips("设置成功")
              } else {
                switch (data.code) {
                  case 3000:
                    this.showErrorTips('当前账号没有权限（3000）');
                    break;
                  default:
                    this.showErrorTips('获取列表失败，服务器返回错误码' + data.code);
                    break
                }
              }
            } else {
              this.showErrorTips('请求失败，HTTP错误码' + response.status);
            }
          }
      ).catch(error => {
        if (error.response.status === 403) {
          localStorage.clear();
          this.$router.replace('/login')
        } else {
          this.showErrorTips('未知错误' + error);
        }
      })
    },
    showTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
    showErrorTips: function (message) {
      this.toast = true
      this.toastMsg = message
    },
  }
}
</script>

<style scoped>
.table_head {
  text-align: center;
}

#publish_content {
  padding: 0 10px;
}

#loading_content {
  padding: 50px 0;
}

.md-layout-item {
  margin-right: 20px;
}
</style>